import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import dayjs from 'dayjs';
import { NgOtpInputComponent } from 'ng-otp-input';
import { CommonService } from 'src/app/services/common/common.service';
import { CoreService } from 'src/app/services/core/core.service';

@Component({
    selector: 'xa-otp-verification',
    templateUrl: './otp-verification.component.html',
    styleUrls: ['./otp-verification.component.scss'],
    standalone: false
})
export class OtpVerificationComponent implements OnInit {
  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput: NgOtpInputComponent;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;

  otpConfig: any = {
    length: 4,
    allowNumbersOnly: true,
    disableAutoFocus: true,
    inputClass: ''
  };
  currentOTPValue: string;
  enableOtp: boolean = false;
  errorMessages: string = null;
  token: any;
  selectedEmail: any;
  selectedPhoneNo: any;
  action: any;
  source: any;
  externalToken: any;
  authentication: any;
  currentModule: any;
  isLinkExpired: boolean = false;

  /**
   * constructor
   * @param commonService
   * @param coreService
   */
  constructor(
    private readonly commonService: CommonService,
    private readonly coreService: CoreService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.token = this.route.snapshot.queryParams['token'];
    const obj: any = atob(this.token);
    const parsedObj = JSON.parse(obj);
    this.selectedEmail = parsedObj.GarageEmail || parsedObj.Email;
    this.selectedPhoneNo = parsedObj.MobileNumber;
    this.action = parsedObj.Action;
    this.source = this.route.snapshot.queryParams['source'] || 'email';
    this.externalToken = parsedObj.ExternalToken;
    this.authentication = parsedObj.Authentication;
    this.route.data?.subscribe((data: any) => {
      this.currentModule = data.module || 'claims';
    
      this.cdr.markForCheck();});
    const expiryTime = dayjs.utc(parsedObj.LinkExpirationTimeStamp);
    if (dayjs().isAfter(expiryTime)) {
      this.isLinkExpired = true;
    }
  }

  /**
   * on init
   */
  ngOnInit(): void {
    this.commonService.dismissBootstrapLoader();
    this.sendOtp();
  }

  /**
   * on otp change
   * @param event
   */
  onOtpChange(event: string): void {
    if (event.length == 4) {
      this.currentOTPValue = event;
      this.enableOtp = true;
    } else {
      this.enableOtp = false;
    }
  }

  /**
   * send otp
   */
  sendOtp(): void {
    this.commonService.showLoading();
    this.coreService.generateEmailOTP(this.selectedEmail).subscribe({
      next: (res) => {
        this.errorMessages = '';
        this.otpConfig.inputClass = '';
        this.ngOtpInput.setValue('');
        const inputs = document.getElementsByClassName('otp-input');
        if (inputs) {
          for (let i = 0; i < inputs.length; i++) {
            (inputs[i] as HTMLInputElement).disabled = false;
          }
        }
        this.commonService.hideLoading();
      
      this.cdr.markForCheck();},
      error: () => {
        this.commonService.hideLoading();
      }
    });
  }

  /**
   * verify otp
   * @param otp
   */
  verifyOtp(): void {
    const payload = {
      otpCode: this.currentOTPValue,
      userIdType: this.source,
      isExternalToken: 'true',
      emailorPhoneNumber: this.selectedEmail
    };
    this.commonService.showLoading();

    this.coreService.generateTokenFromOTP(payload).subscribe({
      next: async (res: any) => {
        if (res.success) {
          const obj = {
            accessToken: res?.data.accessToken,
            refreshToken: res?.data.refreshToken
          };
          this.coreService.generateRefreshToken(obj).subscribe({
            next: (res: any) => {
              this.commonService.hideLoading();
              const token = { idToken: res?.data.accessToken };
              localStorage.setItem('XAuserDetails', JSON.stringify(token));
              if (res && this.action) {
                this.router.navigateByUrl(`claim/${this.action}?token=${this.token}`);
              } else {
                this.errorMessages = res.errors;
              }
              this.cdr.markForCheck();
            },
            error: (error) => {
              this.errorMessages = error?.error?.msg;
              this.cdr.markForCheck();
            }
          });
        } else {
          this.errorMessages = res?.errors;
        }
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.errorMessages = error?.error?.msg;
        this.cdr.markForCheck();
      }
    });
  }
}
